import { render, staticRenderFns } from "./ExpenseTypeTable.vue?vue&type=template&id=6f34238d"
import script from "./ExpenseTypeTable.vue?vue&type=script&lang=js"
export * from "./ExpenseTypeTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports